/**
 * vjiang
 * 20200828152900
 * order interface
 */
import request from '@/utils/request';

/**
 * 获取订单列表
 * @param params
 */
export function getOrderList(params) {
    return request({
        url: '/business/MagOrdersBuy/list',
        method: 'get',
        params: params
    })
}

/**
 * 获取订单详情
 * @param params
 */
export function getOrder(params) {
    return request({
        url: '/business/MagOrdersBuyDetail/list',
        method: 'get',
        params: params
    })
}

/**
 * 创建订单
 * @param data
 */
export function createOrder(data) {
    return request({
        url: '/business/MagOrdersBuy/add',
        method: "post",
        data: data
    })
}

/**
 * 订单删除
 * @param params
 */
export function deleteOrder(params) {
    return request({
        url: '/business/MagOrdersBuy/delete',
        method: "get",
        params: params
    })
}

/**
 * 订单支付
 * @param data
 */
export function payOrder(params) {
    return request({
        url: '/business/wx/pay',
        method: "get",
        params: params
    })
}

/**
 * 退款
 */
export function refundOrder(params) {
    return request({
        url: '/business/wx/payRefund',
        method: "get",
        params: params
    })
}
